<div *ngIf="!isListMode">
  <div *ngIf="!display">
    <div class="content-wrapper">
      <div>
        <div>
          <div>
            <div class="btn-wrapper">
              <button mat-flat-button class="btn-back btn-warn" color="" aria-label="Back" (click)='back()'>
                <span>{{'questions.typeOfQuestions.surveyStarRating.btnBack' | translate}}</span>
              </button>
              <span class="spacer"></span>
              <button [disabled]="!surveyStarRatingForm.valid" mat-flat-button color="" class="btn-primary" aria-label="Save"
                (click)="saveSurveyStarRatingQuestion()">
                <span>{{'questions.typeOfQuestions.surveyStarRating.btnSave' | translate}}</span>
              </button>
            </div>
          </div>
        </div>
      </div>
      <form [formGroup]="surveyStarRatingForm">
        <ng-container>
          <div class="filter-section">
            <div class="body-section title addFlex">
              <mat-icon>library_add</mat-icon> &nbsp;
              <span>{{'questions.typeOfQuestions.surveyStarRating.title' | translate}}</span>
            </div>
            <div class="body-section-2" formGroupName="questiondescription">
              <label class="que-label">{{'questions.typeOfQuestions.surveyStarRating.labelQuest' | translate}}</label>
              <!-- <ngx-editor-menu [editor]="questionEditor" [toolbar]="toolbar">
              </ngx-editor-menu>
              <ngx-editor [editor]="questionEditor" [placeholder]="'Enter here...'" formControlName="description"></ngx-editor> -->
              <ckeditor #myEditor formControlName="description" [editor]="Editor" (ready)="onReady($event)" (click)="onClick(true)"></ckeditor>
              <div *ngIf="errorMessage" class="alert alert-danger">{{ errorMessage }}</div>
              <!-- <ckeditor formControlName="description" data="Enter here..." [config]="ckeditorConfig" [ngClass]="{'ckeditor-loading': isCkeditorLoading}" (ready)="onCkeditorReady()"></ckeditor> -->

            </div>
          </div>
          <div *ngIf="validateQuestion" class="text-msg">
            <span>Please add the question first</span>
          </div>
        </ng-container>
        <ng-container>
          <!-- <div class="btn-container">
            <button mat-flat-button color="" class="btn-warn" class="btn-bg-color" (click)='validateAndAddOption()'>Add
              Star</button>
          </div> -->
          <div class="score-wrapper">
            <div class="add-option d-block">
              <div class="list-of-star-rating" [formArrayName]="reuseProp.options">
                <div class="input-class-container" *ngFor="let o of this.optionObject.controls; let i = index" [formGroupName]="i">
                  <div class="add-star-input">
                    <label for="o{{i}}" style="font-weight: 400;width: 200px;">{{'questions.typeOfQuestions.surveyStarRating.starRatings.label1' | translate}}<span class="error">*</span></label>
                    <input class="radio-btn-class" type="number" name="o" formControlName="optionId">
                    <mat-error *ngIf="o.get('optionId').errors?.['whitespace']">
                      {{'questions.typeOfQuestions.surveyStarRating.starRatings.errorRequired' | translate}}
                    </mat-error>
                  </div>
                </div>
              </div>
              <div class="input-class-container">
                <div class="add-star-input">
                  <label for="" style="font-weight: 400;width: 200px;">{{'questions.typeOfQuestions.surveyStarRating.starRatings.label2' | translate}}</label><input class="radio-btn-class" type="text"
                    formControlName="Ratinglow" name="o" min="3">
                </div>
              </div>
              <div class="input-class-container">
                <div class="add-star-input">
                  <label for="" style="font-weight: 400;width: 200px;">{{'questions.typeOfQuestions.surveyStarRating.starRatings.label3' | translate}}</label><input class="radio-btn-class" type="text"
                    formControlName="Ratinghigh" name="o">
                </div>
              </div>
            </div>
          </div>
        </ng-container>
        <div class="exp-panel">
          <mat-accordion>
            <mat-expansion-panel>
              <mat-expansion-panel-header>
                <mat-panel-title>
                  {{'questions.typeOfQuestions.surveyStarRating.accordian.title' | translate}}
                </mat-panel-title>
              </mat-expansion-panel-header>
              <div class="container-fluid  body-section-2">
                <div class="row">
                  <div class="col-md-2 answers-label">
                    <div class="form-label">
                      <label>{{'questions.typeOfQuestions.surveyStarRating.accordian.selectOptions.option1.label' | translate}}</label>
                    </div>
                  </div>
                  <div class="col-md-3">
                    <mat-form-field class="scoring-type" appearance="fill">
                      <mat-select formControlName="questiondisplayoptions">
                        <mat-option [value]="option.title" *ngFor="let option of QuestionOrientation">{{option.title}}</mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>
                </div>
              </div>
            </mat-expansion-panel>
          </mat-accordion>
        </div>
      </form>
    </div>
  </div>
  <div *ngIf="display">
    <app-choose-question-type></app-choose-question-type>
  </div>
</div>

<div *ngIf="isListMode">
  <app-question-list></app-question-list>
</div>
